import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FilterSelect from 'components/search_sidebar/filter_select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgressBar } from 'react-bootstrap';

import { updateFile } from '../store/actions/import_object';
import FileStatus from './file_status';

export class FileCard extends React.Component {
  static propTypes = {
    file: PropTypes.shape({
      completedRecords: PropTypes.number,
      mapperType: PropTypes.string,
      name: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      totalRecords: PropTypes.number
    }).isRequired,
    mapperTypeOptions: PropTypes.array.isRequired,
    onUpdateFile: PropTypes.func.isRequired
  }

  handleMapperTypeSelect = (e) => {
    const { file, onUpdateFile } = this.props;
    const value = e.target.value;
    const newFile = { ...file };
    newFile.mapperType = value;
    onUpdateFile(newFile);
  }

  renderBody() {
    const { mapperTypeOptions, file } = this.props;

    return (
      <div className="file-body panel-body">
        <div className="pull-left">
          <div className="bold text-large">Data Type</div>
          <div>What type of data are you trying to import from this spread sheet?</div>
        </div>
        <div className="pull-right w-50 mt-2">
          <FilterSelect
            options={mapperTypeOptions}
            placeholder="Do Not Import"
            value={file.mapperType}
            onChange={this.handleMapperTypeSelect}
          />
        </div>
      </div>
    );
  }

  renderProgressBar() {
    const { file } = this.props;
    let status = 0;
    if (file.totalRecords != 0 && file.completedRecords != 0) {
      status = (parseFloat(file.completedRecords) / parseFloat(file.totalRecords)) * 100;
    }

    return (
      <div className="ph-5 mt-3">
        <ProgressBar active label={`${parseInt(status)}%`} now={parseInt(status)}/>
        <FileStatus file={file}/>
      </div>
    );
  }

  render() {
    const { file } = this.props;

    return (
      <div className="panel panel-default">
        <div className="file-header panel-body">
          <FontAwesomeIcon className="mr-3" icon="file-csv" size="2x" />
          <div className="mt-2">{file.name}</div>
        </div>
        {file.status != "ready" ? this.renderProgressBar() : this.renderBody()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  mapperTypeOptions: state.static.mapperTypeOptions
});

const mapDispatchToProps = {
  onUpdateFile: updateFile
};

export default connect(mapStateToProps, mapDispatchToProps)(FileCard);
